<div class="order-notes-container bdr-btm">
  <div class="flex-box">
    <div class="heading">Order notes</div>
    <img src="/assets/images/add.svg" alt="" class="icon pointer" (click)="showAddNote = true">
  </div>
  <order-note [order]="orderObj" [note]="note" (noteUpdated)="note = $event" [showAddNote]="showAddNote"></order-note>
  <!-- <hr> -->
</div>